{
  "accept": "同意する",
  "activate account": "アカウントを有効にする",
  "added doctor to favorite doctror": "{name} さんを興味のある医師として登録しました。",
  "addFiles": "添付ファイル",
  "after payment is confirmed, completed.": "決済確認後、受付は完了です。",
  "agree": "同意",
  "agree to all terms and conditions": "すべての利用規約に同意します。",
  "agree to all terms and conditions.": "すべての利用規約に同意します。",
  "agreeAll": "すべての同意",
  "Agreement": "利用規約",
  "Agreement Content": "利用規約",
  "allowingRecive": "受信の同意",
  "attach files": "ファイルの添付",
  "attached files": "ファイルの添付",
  "Attachments": "添付",
  "available email": "利用可能なメール",
  "back": "戻る",
  "birthDate": "生年月日 (2000/01/01)",
  "CalcelHeader": "キャンセルしますか？",
  "cancel": "キャンセル",
  "Cancel": "キャンセル",
  "cancel payment and reservation": "決済キャンセルとキャンセル",
  "cancel reservation": "予約のキャンセル",
  "canceled": "キャンセル",
  "Canceled": "キャンセル",
  "change": "変更",
  "change docor": "医師変更",
  "change password": "パスワードの変更",
  "changed password": "パスワードが変更されました。",
  "changePassword": "パスワードの変更",
  "check email": "{email}メールを確認してください。",
  "check email verificaion": "メールの重複確認をしてください。",
  "check payment": "決済確認",
  "check prescription": "処方箋の確認",
  "check spam mail box": "スパムメールボックスを確認してください",
  "Check your email or password": "ログイン情報を確認してください。",
  "CheckingItNow": "確認中です。",
  "chief complaint": "主症状",
  "chief complaint & files": "症状とファイルの添付",
  "close": "閉じる",
  "complete": "完了",
  "complete to sign-up": "ボタンを選択すると会員登録が完了します。",
  "Completed": "返信完了",
  "confirm": "確認",
  "confirm cancel reservation": "予約をキャンセルした後は修正できません。^ その予約をキャンセルしてもよろしいですか？",
  "confirm delete file": "該当するファイルを削除しますか?",
  "confirm new password": "新規パスワードの確認",
  "confirm reservation": "予約確定",
  "confirm withdrawal": "本当に脱退しますか？",
  "confirm2": "内容の確認",
  "confirmed within one hour on average": "平均1時間以内に確定",
  "confirmemail": "メール確認",
  "DataType": "ファイルの種類",
  "date (from)": "開始日",
  "date(to)": "開始日",
  "dayNames": "日曜日,月曜日,火曜日,水曜日,木曜日,金曜日,土曜日",
  "dayNamesMin": "日,月,火,水,木,金,土",
  "dayNamesShort": "日,月,火,水,木,金,土",
  "default": "基本",
  "desired date": "希望診療日",
  "desired date/time": "希望日時",
  "desired date/time can be selected after doctor selected": "希望日と希望時間は医師選択後に選択および変更可能",
  "desired time": "希望の診療時間",
  "did you not receive verification code via email": "もし認証番号をメールで受信できませんでしたか？",
  "didnt receive verification email": "認証メールを受信できませんでしたか？",
  "direct input": "直接入力",
  "Dispense": "調剤完了",
  "do change": "変更する",
  "do not show one week": "7日間表示しない",
  "do save": "保存する",
  "doctor": "医師",
  "doctor name": "医師名",
  "doctor or dept": "医師 or 診療科",
  "doctor response": "医師の返信",
  "download": "ダウンロード",
  "Drag and drop files to here to upload.": "添付ファイルをマウスでドラッグするか、[ファイル選択]ボタンをクリックしてください。",
  "drop files to here": "ファイルをドロップしてください",
  "edit": "修正",
  "edit personal information": "個人情報の修正",
  "edit requested data": "診療協力予約の修正",
  "email": "メール",
  "email already in use": "既に使用中のメール",
  "email confirmed": "メール認証が確認されました。",
  "EmailCheck": "重複確認",
  "EmailSendOK": "入力したメールにメールが送信されました。",
  "emptyMessage": "",
  "enter at least two characters without spaces": "空白を除く 2 文字以上入力してください。",
  "error": "エラー",
  "Error": "エラー",
  "error occured. please retry later": "エラーが発生しました。しばらくしてからもう一度お試しください。",
  "failed to save": "保存に失敗しました",
  "failed to sign up": "会員登録に失敗しました",
  "familyName": "姓",
  "favorite doctors": "関心の医師",
  "female": "女",
  "fetch failed": "サービスに接続できません。",
  "file-list": {
    "desc": {
      "a": "DICOM画像は .ZIPファイルに圧縮後アップロード",
      "b": "iPhoneで撮影した動画が見えないとき",
      "c": "ここ",
      "d": "を押す",
      "e": "[メディアをキャプチャする]",
      "f": "を参照してください"
    }
  },
  "FileAttachments": "症状写真付き",
  "FileCancel": "添付のキャンセル",
  "FileChoose": "ファイルの選択",
  "FileManager": "ファイル管理",
  "FileTitle": "ファイル名",
  "FileType": "ファイル拡張子",
  "Fileupload": "ファイルの添付",
  "fill-form-data": "登録に必要な必須情報を入力してください。",
  "filtered by dept": "診療科で検索",
  "finding keywords (requested)": "医師、病院、診療科など",
  "finished sign up": "完了しました。",
  "first name": "名",
  "firstName": "名前",
  "fold": "折りたたみ",
  "forgotPassword": "パスワードの紛失",
  "ForOpinion": "所見申請",
  "from date": "開始日",
  "full name": "名前",
  "home": "ホーム",
  "home-intro-1": "今までとは異なるケア、",
  "home-intro-2": "少し特別な非対面ケアHESEL",
  "how to take appointment for non-face-to-face cooperation": "専門医を選択して症状を送信すると、協調予約申請が完了します。",
  "impossible to confirm": "確認できません",
  "InfoModify": "会員情報の修正",
  "input chief complaint": "主症状の入力",
  "input new password": "新しいパスワードを入力してください。",
  "input new password confirm": "新しいパスワードをもう一度入力してください。",
  "input old password": "既存のパスワードを入力してください。",
  "input your email address": "会員登録時に入力したメールを入力してください",
  "input-email": "メールアドレスを入力してください。",
  "input-password": "パスワードを入力してください。",
  "insertDateTime": "申請日",
  "join": "登録",
  "korea standard time": "韓国標準時",
  "last name": "姓",
  "LastOrder": "最近のお支払い",
  "legal": "個人情報処理方針 / 利用規約",
  "List of Doctors": "医師の選択",
  "login failed": "ログインエラー",
  "make sure the correct email address": "正しいメールアドレスを登録したことを確認してください",
  "male": "男",
  "medically-vulnerable": "医療の脆弱性",
  "mofidy requested second opinion": "所見申請の修正",
  "monthNames": "1月,2月,3月,4月,5月,6月,7月,8月,9月,10月,11月,12月",
  "monthNamesShort": "1月,2月,3月,4月,5月,6月,7月,8月,9月,10月,11月,12月",
  "more": "もっと",
  "my doctors": "関心の医師",
  "my page": "マイページ",
  "MyPage": "マイページ",
  "name": "名前",
  "new password": "新規パスワード",
  "newPassword": "新しいパスワード",
  "newPasswordConfirm": "新しいパスワードの確認",
  "newRequest": "申請する",
  "newRequestOnlineCare": "予約申請",
  "newRequestSecondOpinion": "二次所見を申請する",
  "next": "次へ",
  "Next": "次へ",
  "No": "いいえ",
  "non-face-to-face cooperation": "非対面診療協力",
  "not confirmed email": "メールを確認できません",
  "ok": "OK",
  "online-care-intro-1": "高血圧、糖尿病などの慢性疾患、風邪などの一般疾患の診療",
  "online-care-intro-2": "予約日にビデオチャットで非対面診療協力",
  "OnlineCare": "オンライン診療（処方箋）",
  "Page not found": "ページが見つかりません。",
  "paid history": "支払い履歴",
  "paid list": "支払い履歴",
  "paid then completed": "お支払い後の受付は完了です。",
  "password": "パスワード",
  "password changed": "パスワードが変更されました。",
  "Password not correct": "パスワードが一致しません。",
  "password was changed or expired": "パスワードが既に変更されているか、変更期間が期限切れです。",
  "password-rules": "6桁以上、文字、数字",
  "passwordConfirm": "パスワードの確認",
  "pay": "支払い",
  "payment": "支払い",
  "PayReady": "支払い待機",
  "pharmacy": "薬局",
  "PharmacyNone": "選択しない",
  "phoneNumber": "携帯電話番号",
  "pi-agreement": "個人情報提供同意",
  "prescription": "処方箋",
  "Prev": "前へ",
  "previous": "前へ",
  "privacy": "個人情報処理方針",
  "Privacy Policy": "個人情報処理方針",
  "Privacy Policy Content": "個人情報処理方針",
  "proceeding": "進行中",
  "profile": "個人情報",
  "quick": "高速",
  "quick reservation description": "お好みの医師と希望の日/時の選択を通じてケアを申し込みます。",
  "ReceptionCompleted": "受付完了",
  "ReceptionSaveHeader": "受け取りますか？",
  "recommendted browsers": "推奨ブラウザ",
  "refresh": "更新する",
  "refund and reject": "払い戻しの完了と返済",
  "refunded": "払い戻し処理",
  "Refused": "拒否",
  "registrationcompleted": "登録完了",
  "reject": "撤回する",
  "rejected": "拒否",
  "remember me": "ログインを維持",
  "remove": "削除",
  "Remove": "削除",
  "request": "依頼",
  "request appointment": "受付",
  "request comments": "予約コメント",
  "request kind": "タイプ",
  "request quick reservation": "クイックケア申請",
  "request reservation": "申請受付",
  "request second opinion": "二次所見要求",
  "requested": "申請完了",
  "Requested": "予約申請",
  "requested and wait payid": "申請と決済待機",
  "requested count": "申請件数",
  "requested list": "申請履歴",
  "RequestedQuick": "クイックケア",
  "required": "必須",
  "Required information is required": "必須情報を入力してください。",
  "required phone number for servie": "サービスを利用するために携帯電話番号を入力してください。",
  "resend verification email": "認証メールの再送信",
  "reserved date/time": "予約日時",
  "reset": "リセット",
  "reset password": "パスワードの初期化",
  "resetpassword": "パスワードの変更",
  "resetPasswordCompleted": "パスワードの変更に成功しました。",
  "respond count": "返信完了",
  "respond list": "完了履歴",
  "respondDateTime": "返信日",
  "responded": "完了",
  "response": "返信",
  "Result": "結果",
  "Return": "戻る",
  "save": "保存",
  "save response": "返信を保存",
  "Saved": "保存完了。",
  "saved requesting reservation": "申請の受付が完了しました。",
  "SavedFavorites": "主治医として選択しました。",
  "SaveHeader": "保存しますか？",
  "Scheduled": "予約確認",
  "scheduled date/time": "予約日時",
  "scheduledDatetime": "予約日時",
  "search": "検索",
  "search failed": "検索エラー",
  "second opinion": "二次所見",
  "second-opinion-intro-1": "他の病院がん治療、手術などの検査ファイルに基づいて",
  "second-opinion-intro-2": "専門の所見が必要な場合(3～7日かかる)",
  "SecondOpinion": "Second Opinion (二次所見)",
  "SecondOpinion2": "二次所見",
  "Select a Dept": "診療と選択",
  "select a hospital": "病院の選択",
  "Select a hospital": "病院の選択",
  "select a hospital to requesting": "診療を受ける病院を選択してください。",
  "select desired date/time": "希望日時を選択",
  "select doctor": "医師の選択",
  "select hopital and doctor": "病院と医師の選択",
  "sent confirming email": "認証メールが送信されました。",
  "sent verification email": "認証メールが送信されました。",
  "serious illness": "重症疾患",
  "sex": "性別",
  "sexF": "女性",
  "sexM": "男性",
  "show detail": "もっと見る",
  "show detail profile": "プロフィールの詳細を表示",
  "sign in": "ログイン",
  "Sign in": "LOGIN",
  "sign out": "ログアウト",
  "sign up": "会員登録",
  "sign-in-titl-1": "診療時間を選択して非対面診療協力を受けることができ、",
  "sign-in-titl-2": "重症疾患に対する二次所見を提供するサービスです。",
  "sign-up": "会員登録",
  "signin": "ログイン",
  "Signout": "ログアウト",
  "signup": "会員登録",
  "signup-title": "まだ メンバーではありませんか？",
  "signup-title-1": "会員管理のために以下のように個人情報を収集・利用および提供したいと思います。",
  "signup-title-2": "内容をよく読んでから同意するかどうかを決定してください。",
  "sms": "ショートメッセージ",
  "Status": "現状",
  "submit": "確認",
  "submit application": "送信",
  "take appointment": "診療協力予約",
  "take appointment for non-face-to-face cooperation": "協力予約申請",
  "take average one week": "3〜7日かかる",
  "terms of use": "利用規約",
  "there is no selectable doctors": "選択できる医師がいません。",
  "time standard": "基準",
  "title": "タイトル",
  "to date": "終了日",
  "toggle favarite doctor": "もう一度クリックして興味のある医師を解放することができます。",
  "totalCallTime": "通話時間",
  "Unable to load user": "ユーザーが見つかりません。",
  "unfold": "開く",
  "update is completed": "修正されました。",
  "User account locked out": "ログイン試行を超えて、しばらくしてからもう一度お試しください。",
  "User not found": "ユーザーが見つかりません。",
  "userInfo": "ユーザー情報",
  "userName": "ユーザー名",
  "validateError": "必須項目を入力してください。",
  "Video": "画像相談",
  "video chat": "画像診療",
  "view prescription": "処方箋を見る",
  "withdrawal": "会員脱退",
  "withdrawal info1": "会員を退会すると、会員の診療記録",
  "withdrawal info2": "すべて削除され、復元されません。",
  "WithdrawalHeader": "会員を退会します。",
  "Yes": "はい",
  "Your email is not verified": "登録したメールにメールを送信しました。\nメールを開いて[アカウントを有効にする]ボタンを押してください。\nその後、ログインできます。"
}
